import axiosInstance from "api"
import { Endpoint } from "api/enpoints.types"
import { AxiosError, AxiosResponse } from "axios"
import { useQuery } from "react-query"

import { IAsyncTaskArgs, IResponseAsyncTask } from "./tasks.types"

export const ASYNC_TASK_POLL_INTERVAL_MS = 5 * 1000

export const useQueryAsyncTask = (args?: IAsyncTaskArgs) =>
  useQuery<AxiosResponse<IResponseAsyncTask>, AxiosError>(
    ["asyncTask", args?.task_id],
    async () =>
      axiosInstance(
        Endpoint.ASYNCTASKS_ID_STATE.replace("ID", `${args?.task_id}`)
      ),
    {
      ...args?.options,
    }
  )
